import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CertificationEvaluationEvent } from '../models/pns-event';
import { UserWithRole } from '../models/user';

@Injectable({
  providedIn: 'root',
})
export class FiltersService {
  private http = inject(HttpClient);

  public getReferenceNames(textSearch: string): Observable<CertificationEvaluationEvent[]> {
    return this.http.post<CertificationEvaluationEvent[]>(
      `${environment.baseApiUrl}/api/certifications/evaluations`, {textSearch}
    );
  }

  public getUserEmails(textSearch: string): Observable<UserWithRole[]> {
    return this.http.post<UserWithRole[]>(
      `${environment.baseApiUrl}/api/users`, {textSearch},
    );
  }
}
